import { TextSkeleton } from 'src/modules/shared/components/atoms/text/text-skeleton';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

interface SidebarGroupsSkeletonProps {
  /** Match the navigation icon size and inset for this layout. */
  variant: 'desktop' | 'mobile';
}

const labelWidths = ['!w-28', '!w-20', '!w-24'];

/** Loading placeholders using the same row heights and icon track as navigation. */
export function SidebarGroupsSkeleton({ variant }: SidebarGroupsSkeletonProps) {
  const { t } = useI18n();
  const isDesktop = variant === 'desktop';

  return (
    <div role="status" aria-label={t('sidebar.loading')} aria-busy="true">
      <div aria-hidden="true" className={isDesktop ? '' : 'space-y-4'}>
        {[3, 2, 2].map((itemCount, groupIndex) => (
          <div key={groupIndex} className="flex flex-col gap-1.5">
            <div
              className={`relative flex items-center ${isDesktop ? 'h-8 px-3' : 'mt-2 h-4 px-4'}`}
            >
              <span data-sidebar-divider />
              <div data-sidebar-label className="w-20">
                <TextSkeleton
                  variant="neutral"
                  className="!h-3 motion-reduce:animate-none"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1.5">
              {Array.from({ length: itemCount }, (_, itemIndex) => (
                <div
                  key={itemIndex}
                  data-sidebar-item
                  className="flex h-8 items-center gap-2 px-3"
                >
                  <div data-sidebar-icon className="shrink-0">
                    <TextSkeleton
                      variant="neutral"
                      className={`${isDesktop ? '!h-5 !w-5' : '!h-6 !w-6'} motion-reduce:animate-none`}
                    />
                  </div>
                  <div data-sidebar-label className="min-w-0 flex-1">
                    <TextSkeleton
                      variant="neutral"
                      className={`!h-3.5 ${labelWidths[itemIndex]} motion-reduce:animate-none`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
